var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$route.path === "/dashboard" &&
    _vm.$vuetify.breakpoint.name != "xs"
    ? _c(
        "v-sheet",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.desserts.length > 0,
              expression: "desserts.length > 0",
            },
          ],
          staticClass: "mx-n3 mt-n3 transparent black--text rounded-lg",
        },
        [
          _c(
            "v-carousel",
            {
              attrs: {
                cycle: "",
                height: "115",
                "show-arrows": false,
                "hide-delimiter-background": "",
                "delimiter-icon": "mdi-circle",
              },
            },
            _vm._l(_vm.desserts, function (announecment, i) {
              return _c(
                "v-carousel-item",
                { key: "announecment---" + i },
                [
                  _c(
                    "v-sheet",
                    { attrs: { height: "100%", color: "#FDF3CD" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "fill-height",
                          attrs: {
                            dense: "",
                            align: "center",
                            justify: "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-decoration-underline text-body-1 text--primary",
                              on: {
                                click: function ($event) {
                                  return _vm.toView(announecment.uuid)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(announecment.message_title) + " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c("viewAnnouncement", {
            attrs: { show: _vm.showDetail, canEdit: "", curUuid: _vm.curUuid },
            on: {
              close: function ($event) {
                _vm.showDetail = false
                _vm.curUuid = null
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }